<template>
  <div id="app">
    <a-spin tip="กำลังโหลดข้อมูล..." :spinning="$store.state.isLoading" size="large">
      <router-view></router-view>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.state.screenWidth = window.innerWidth
      this.$store.state.screenHeight = window.innerHeight
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue